import React from 'react';
import { WorkPageLayout } from '../Layout';
import styles from './Guide.module.scss';

export const GuideStepThree = () => (
  <WorkPageLayout
    leftContent={
      <div className={styles.guideLeftSection}>
        <span className={styles.guideStepLeft_1}>The</span>
        <span className={styles.guideStepLeft_2}>Guide</span>
        <span className={styles.guideStepLeft_3}>to a sustainable</span>
        <span className={styles.guideStepLeft_4}>technological</span>
        <span className={styles.guideStepLeft_5}>future</span>
      </div>
    }
    rightContent={
      <div className={styles.guideStepContentWrapper}>
        <ul>
          <li style={{ marginBottom: 20 }}>
            Accurate data is crucial for optimal cooperation. All interactions, document flow,
            consultations, and purchases on TransparenTerra are protected and verified.
          </li>
          <li>
            Transparency, openness, and a unique methodology for calculating the ESG score all
            provide an accurate picture of the sustainability of companies and projects.
          </li>
        </ul>
      </div>
    }
  />
);
